/**
 * Platform Download Hook
 * Thin wrapper around core download hook for platform datadrive
 */

import { PlatformFSContext } from './core/context'
import { useDownloadCore } from './core/hooks/useDownload'

// Re-export types for convenience
export type { DownloadStatus, IDownloadTask } from './core/types'

// Singleton platform context
const platformContext = new PlatformFSContext()

/**
 * Platform download hook with progress tracking
 * @returns Download state and control functions
 */
export function useDownload() {
  return useDownloadCore(platformContext)
}
